module.exports = __webpack_public_path__ + "static/img/logo.d5338d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 625
// module chunks = 1